export const MAINTENANCE_LIST_PATH = '/service/maintenance-list';
